<script>
import Multiselect from 'vue-multiselect'
export default {
  components: {
    Multiselect,
  },
  props: {
    fieldId: {
      type: String,
      default: '',
      required: false,
    },
    options: {
      type: Array,
      default: Array,
    },
  },
  data: function() {
    return {
      totoalCount: 0,
    }
  },
  computed: {
    recCount() {
      if (this.options[0].items) {
        return this.options[0].items.length
      } else  if(this.options){
          return this.options.length
        }
        else{
          return 0
        }
    }
  },
  methods: {
    customLabel(option) {
      return `${option.text} - ${option.id}`
    },
    onSelect(option) {
      let index = this.options.findIndex((item) => item.text === option.text)
      this.options[index].checked = true
    },

    onRemove(option) {
      let index = this.options.findIndex((item) => item.text === option.text)
      this.options[index].checked = false
    },
  },
}
</script>

<template>
  <div>
    <Multiselect
      :options="options"
      select-label=""
      deselect-label=""
      :show-labels="false"
      :searchable="true"
      :clear-on-select="false"
      :preserve-search="false"
      v-bind="$attrs"
      :class="$style.multiselect"
      v-on="$listeners"
      @input="$emit('update', $event)"
    >
      <!-- eslint-disable-next-line vue/no-unused-vars -->
      <template slot="tag" slot-scope="{ option, remove }"><span /></template>
      <template slot="selection" slot-scope="{ values, search, isOpen }">
        <span v-if="values.length > 0 && !isOpen" class="multiselect__single">
          {{ values.length }} of {{ recCount }} option[s] selected
        </span>
      </template>
    </Multiselect>
  </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" module>
@import '@design';
.multiselect {
  font-size: 12px;
}
.selectbg {
  background-color: $color-button-bg !important;
  border: $input-border;
}
.multiCheckPos {
  position: absolute;
  right: 1vw;
}
</style>
